
import { MapLocation } from '@/types/location';

// Train Way Gym Locations
export const trainWayGyms: MapLocation[] = [
  {
    id: 24001,
    name: "Train Way - Riyadh (Hittin)",
    type: "Gym",
    devices: 3,
    coordinates: [24.759348480572886, 46.60610737791171],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "15-40",
    orientation: "Portrait",
    segment: "Fitness"
  }
];
